/**
 * Enum representing content types supported by the Media Viewer component
 * - `APPLICATION_PDF`: PDF document.
 * - `APPLICATION_JSON`: JSON document.
 * - `IMAGE_PNG`: PNG image.
 * - `IMAGE_JPEG`: JPEG image.
 */

export enum MediaViewerContentType {
    APPLICATION_PDF = 'application/pdf',
    APPLICATION_JSON = 'application/json',
    IMAGE_PNG = 'image/png',
    IMAGE_JPEG = 'image/jpeg',
}

/** All content types the media viewer can display (enum values). */
export const MEDIA_VIEWER_CONTENT_TYPES: readonly MediaViewerContentType[] =
    Object.values(MediaViewerContentType);
